module.exports = __webpack_public_path__ + "img/driver-licence.9b5ab8f8.png";